import{isCompoundComponent as o}from"../CompoundComponent/CompoundComponent.js";var n=function(n){return o(n)};export{n as isCC};
